import React from 'react';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableRow from '@material-ui/core/TableRow';
import {Button, makeStyles, Modal} from '@material-ui/core';

function getModalStyle() {
    const top = 50;
    const left = 50;

    return {
        top: `${top}%`,
        left: `${left}%`,
        transform: `translate(-${top}%, -${left}%)`,
    };
}

function ModalBox(props) {

    const useStyles = makeStyles((theme) => ({
        paper: {
            position: 'absolute',
            width: 400,
            backgroundColor: theme.palette.background.paper,
            border: '2px solid #000',
            boxShadow: theme.shadows[5],
            padding: theme.spacing(2, 4, 3),
        },
    }));
    const classes = useStyles();

    return (

        <Modal
            open={props.showPlayerProfile !== null}
            aria-labelledby="simple-modal-title"
            aria-describedby="simple-modal-description"
            onClose={() => props.stopShowingPlayerInfo()}
        >
            <div style={getModalStyle()} className={classes.paper}>
                {props.showPlayerProfile ?
                    <>
                        <h2 id="simple-modal-title">{props.showPlayerProfile.name}</h2>
                        <TableContainer>
                            <Table className={classes.table} aria-label="simple table">
                                <TableBody>
                                    <TableRow>
                                        <TableCell align="right">
                                            Company
                                        </TableCell>
                                        <TableCell>{props.showPlayerProfile.company || null}</TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell align="right">
                                            Bio
                                        </TableCell>
                                        <TableCell>{props.showPlayerProfile.bio || null}</TableCell>
                                    </TableRow>
                                </TableBody>
                            </Table>
                        </TableContainer>
                        {props.showPlayerProfile.image_url ?
                            <img src={props.showPlayerProfile.image_url} height="250px" width="250px"
                                 alt="user"></img> : null}
                    </>
                    : null}

                <Button
                    variant="outlined"
                    onClick={() => props.stopShowingPlayerInfo()}
                >
                    Close
                </Button>
            </div>
        </Modal>
    );
}

export default ModalBox

  